import genSelectors from "../core/selectors";
import { MODEL } from "../core/reducer";
import { POST_VIEWS_MODEL } from "./reducer";

export default genSelectors([MODEL, POST_VIEWS_MODEL]);
